import { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext({
  isDark: true,
});

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    // Always enforce dark mode
    const root = window.document.documentElement;
    root.classList.add('dark');
    localStorage.setItem('theme', 'dark');
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark: true }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
